<template>
    <div
        class="operation"
        :style="`left: ${newLeft}px;top: ${newTop}px;`"
        v-if="newIsShow"
    >
        <h2>{{newTitle}}操作</h2>
        <p
            v-for="(item,index) in newForm"
            :key="index"
            class="item"
            @click="handleClick(item)"
        ><i :style="`background-image:url(${$images.oper[item.key]});`"></i>{{item.value}}</p>
    </div>
</template>

<script>
    export default {
        name: "operation",
        props: {
            item: Object,
            isShow: {
                type: Boolean,
                default: false
            },
            title: String,
            form: Array,
            left: Number,
            top: Number
        },
        watch: {
            item(vl){this.newItem = vl},
            newItem(vl){this.$emit('update:item',vl)},
            isShow(vl){this.newIsShow = vl},
            newIsShow(vl){this.$emit('update:isShow',vl)},
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form',vl)},
            left(vl){this.newLeft = vl},
            newLeft(vl){this.$emit('update:left',vl)},
            top(vl){this.newTop = vl},
            newTop(vl){this.$emit('update:top',vl)},
            title(vl){this.newTitle = vl},
            newTitle(vl){this.$emit('update:title',vl)},
        },
        data(){
            return {
                newIsShow: this.isShow,
                newForm: this.form,
                newLeft: this.left,
                newTop: this.top,
                newTitle: this.title
            }
        },
        methods: {
            close(){
                this.newIsShow = false
            },
            handleClick(type){
                this.$emit('onOperation', type, this.item)
                this.close()
            }
        }
    }
</script>

<style lang="scss" scoped>
.operation{
    position: absolute;
    left: 0px;
    top: 0px;
    display: flex;
    flex-direction: column;
    z-index: 1200;
    background-color: white;
    box-shadow: 0 0 5px #888;
    box-sizing:border-box;

    h2{
        padding: 0px 15px 10px 15px;
        width:100%;
        height: 35px;
        line-height:35px;
        font-size: 14px;
        float:left;
        background-color:#f2f2f2;
        box-sizing:border-box;
        border-bottom: 1px solid #dddddd;
    }
    .item{
        font-size: 14px;
        padding: 0px 30px 0px 10px;
        cursor: pointer;
        height:35px;
        line-height: 35px;
        i{
            margin-top:5px;
            margin-right: 10px;
            width:24px;
            height:24px;
            float:left;
            background-size: 20px;
            background-repeat: no-repeat;
            background-position: center;
        }

        &:hover{
            background-color: #f1f1f1;
        }
    }
}
</style>
